// Make sure you have this in the theme.liquid file
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css">
// <script src="https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js"></script>
// <script src="{{ 'splide-library.js' | asset_url }}"></script>

// use this part of code for example
/* <splide-slider-component
  data-per-page="2"
  data-mobile-slides="1"
  data-gap="1.2rem"
  data-breakpoints='{"989":{"perPage":2},"749":{"perPage":1}}'
  style="visibility:hidden;"
>
  <div class="js-slider">  <!-- ovo je bitno -->
    <div>Slide A</div>
    <div>Slide B</div>
    <div>Slide C</div>
    <div>Slide D</div>
  </div>
</splide-slider-component> */

(() => {
  if (customElements.get("splide-slider-component")) {
    return;
  }

  if (!window.Splide) {
    return;
  }

  class Slider extends HTMLElement {
    constructor() {
      super();

      // inicijalne opcije
      this.options = {
        pagination: false,
        perMove: 1,
      };

      // dataset -> properties
      this.gap = this.dataset.gap ?? "2.4rem";
      this.perPage = this.dataset.perPage ?? 3;
      this.mobileSlides = this.dataset.mobileSlides ?? 1;
      this.type = this.dataset.type ?? "slide";
      this.direction = this.dataset.direction || "horizontal";
      this.autoplay = this.dataset.autoplay === "true";
      this.pagination = this.dataset.pagination === "true";
      this.interval = parseInt(this.dataset.interval) || 5000;
      this.pauseOnHover = this.dataset.pauseOnHover === "true";
      this.pauseOnFocus = this.dataset.pauseOnFocus === "true";
      this.pauseOnInteraction = this.dataset.pauseOnInteraction === "true";
      this.rewind = this.dataset.rewind === "true";
      this.loop = this.dataset.loop === "true";
      this.progressBar = this.dataset.progressBar === "true";
      this.arrows = this.dataset.arrows === "true";
      this.drag = this.dataset.drag !== "false";
      this.swipe = this.dataset.swipe !== "false";
      this.speed = parseInt(this.dataset.speed) || 400;
      this.easing = this.dataset.easing || "ease";
      this.focus = this.dataset.focus || "center";
      this.start = this.dataset.start ? parseInt(this.dataset.start, 10) : 0;

      // data-breakpoints (JSON string) -> object
      try {
        this.breakpoints = this.dataset.breakpoints
          ? JSON.parse(this.dataset.breakpoints)
          : {
              989: { perPage: Math.max(1, Math.min(this.perPage, 2)) },
              749: {
                perPage: parseInt(this.mobileSlides, 10) || 1,
                gap: "0.8rem",
              },
            };
      } catch (e) {
        this.breakpoints = {
          989: { perPage: Math.max(1, Math.min(this.perPage, 2)) },
          749: { perPage: parseInt(this.mobileSlides, 10) || 1, gap: "0.8rem" },
        };
      }

      // kompletiraj options
      this.options = {
        ...this.options,
        perPage: parseFloat(this.perPage),
        perMove: 1, // Always move by exactly 1 slide
        gap: this.gap,
        type: this.type,
        direction: this.direction,
        breakpoints: this.breakpoints,
        autoplay: this.autoplay,
        pagination: this.pagination,
        interval: this.interval,
        pauseOnHover: this.pauseOnHover,
        pauseOnFocus: this.pauseOnFocus,
        pauseOnInteraction: this.pauseOnInteraction,
        rewind: this.rewind,
        loop: this.loop,
        arrows: this.arrows,
        drag: this.drag,
        swipe: this.swipe,
        speed: this.speed,
        easing: this.easing,
        focus: this.focus === "0" ? 0 : this.focus || 0, // Use 0 instead of 'center' for proper slide-by-slide movement
        start: this.start,
      };
    }

    // perPage
    get perPage() {
      return this._perPage;
    }
    set perPage(v) {
      this._perPage = parseFloat(v);
      if (this.options) this.options.perPage = this._perPage;
    }

    // gap
    get gap() {
      return this._gap;
    }
    set gap(v) {
      this._gap = v;
      if (this.options) this.options.gap = this._gap;
    }

    // breakpoints
    get breakpoints() {
      return this._breakpoints;
    }
    set breakpoints(v) {
      this._breakpoints = v || {};
      if (this.options) this.options.breakpoints = { ...this._breakpoints };
    }

    // mobileSlides
    get mobileSlides() {
      return this._mobileSlides;
    }
    set mobileSlides(v) {
      this._mobileSlides = parseInt(v, 10) || 1;
    }

    // type
    get type() {
      return this._type;
    }
    set type(v) {
      this._type = v;
      if (this.options) this.options.type = this._type;
    }

    // autoplay
    get autoplay() {
      return this._autoplay;
    }
    set autoplay(v) {
      this._autoplay = v === "true" || v === true;
      if (this.options) this.options.autoplay = this._autoplay;
    }

    // pagination
    get pagination() {
      return this._pagination;
    }
    set pagination(v) {
      this._pagination = v === "true" || v === true;
      if (this.options) this.options.pagination = this._pagination;
    }

    // interval
    get interval() {
      return this._interval;
    }
    set interval(v) {
      this._interval = parseInt(v) || 5000;
      if (this.options) this.options.interval = this._interval;
    }

    // pauseOnHover
    get pauseOnHover() {
      return this._pauseOnHover;
    }
    set pauseOnHover(v) {
      this._pauseOnHover = v === "true" || v === true;
      if (this.options) this.options.pauseOnHover = this._pauseOnHover;
    }

    // pauseOnFocus
    get pauseOnFocus() {
      return this._pauseOnFocus;
    }
    set pauseOnFocus(v) {
      this._pauseOnFocus = v === "true" || v === true;
      if (this.options) this.options.pauseOnFocus = this._pauseOnFocus;
    }

    // pauseOnInteraction
    get pauseOnInteraction() {
      return this._pauseOnInteraction;
    }
    set pauseOnInteraction(v) {
      this._pauseOnInteraction = v === "true" || v === true;
      if (this.options)
        this.options.pauseOnInteraction = this._pauseOnInteraction;
    }

    // rewind
    get rewind() {
      return this._rewind;
    }
    set rewind(v) {
      this._rewind = v === "true" || v === true;
      if (this.options) this.options.rewind = this._rewind;
    }

    // loop
    get loop() {
      return this._loop;
    }
    set loop(v) {
      this._loop = v === "true" || v === true;
      if (this.options) this.options.loop = this._loop;
    }

    // arrows
    get arrows() {
      return this._arrows;
    }
    set arrows(v) {
      this._arrows = v === "true" || v === true;
      if (this.options) this.options.arrows = this._arrows;
    }

    connectedCallback() {
      this.ensureMarkup();
      this.initSlider();
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
    }

    ensureMarkup() {
      // Dozvoli da korisnik ubaci “čiste” slide-ove, a mi ćemo napraviti Splide strukturu
      const root = this.querySelector(".js-slider");
      if (!root) return;

      // Ako već postoji .splide__track, ne diraj
      if (root.querySelector(".splide__track")) return;

      const slides = Array.from(root.children);

      if (!root.classList.contains("splide")) {
        root.classList.add("splide");
      }

      const track = document.createElement("div");
      track.className = "splide__track";

      const list = document.createElement("ul");
      list.className = "splide__list";

      slides.forEach((el) => {
        const li = document.createElement("li");
        li.className = "splide__slide";
        li.appendChild(el); // ubaci originalni čvor
        list.appendChild(li);
      });

      track.appendChild(list);
      root.appendChild(track);
    }

    initSlider() {
      const sliderElement = this.querySelector(".js-slider");
      if (!sliderElement) {
        return;
      }

      if (this.slider) {
        this.slider.destroy();
      }

      // Onemogući default Splide strelice ako koristimo custom
      const customArrows = this.querySelectorAll(
        ".hero-slider__arrow-prev, .hero-slider__arrow-next, .review-section__arrow-prev, .review-section__arrow-next, .ug-review__arrow-prev, .ug-review__arrow-next"
      );
      if (customArrows.length > 0) {
        this.options.arrows = false;
      }

      this.slider = new window.Splide(sliderElement, this.options);
      this.slider.mount();

      const listElement = sliderElement.querySelector(".splide__list");

      // Fix for first click issue: force move if transform is still 0 after click
      const arrows = this.querySelectorAll(".splide__arrow");
      arrows.forEach((arrow, index) => {
        arrow.addEventListener(
          "click",
          (e) => {
            const listEl = sliderElement.querySelector(".splide__list");
            const currentTransform = listEl ? listEl.style.transform : "";

            // Check if this is the first click and transform is still 0
            const isFirstClick =
              currentTransform === "translateX(0px)" ||
              currentTransform === "translateX(0)" ||
              !currentTransform ||
              currentTransform === "none";

            if (isFirstClick && this.slider) {
              // Wait for Splide to process the click, then force the move
              setTimeout(() => {
                const listElAfter =
                  sliderElement.querySelector(".splide__list");
                const transformAfter = listElAfter
                  ? listElAfter.style.transform
                  : "";

                // If transform is still 0, force it
                if (
                  transformAfter === "translateX(0px)" ||
                  transformAfter === "translateX(0)" ||
                  !transformAfter ||
                  transformAfter === "none"
                ) {
                  const currentIndex = this.slider.index;
                  const nextIndex =
                    index === 1 ? currentIndex + 1 : currentIndex - 1; // 1 is next arrow, 0 is prev
                  this.slider.go(nextIndex);
                }
              }, 10);
            }
          },
          true
        ); // Use capture phase to catch before Splide
      });

      // Poveži custom strelice sa slider-om
      if (customArrows.length > 0) {
        this.initCustomArrows();
      }

      // Initialize progress bar if enabled
      if (this.progressBar) {
        this.initProgressBar();
      }

      this.style.visibility = "visible";
    }

    initCustomArrows() {
      // Za review-section strelice (van slide-ova)
      const reviewPrevArrow = this.querySelector(".review-section__arrow-prev");
      const reviewNextArrow = this.querySelector(".review-section__arrow-next");

      if (reviewPrevArrow && this.slider) {
        reviewPrevArrow.addEventListener("click", () => {
          this.slider.go("<");
        });
      }

      if (reviewNextArrow && this.slider) {
        reviewNextArrow.addEventListener("click", () => {
          this.slider.go(">");
        });
      }

      // Za ug-review strelice (van slide-ova)
      const ugReviewPrevArrow = this.querySelector(".ug-review__arrow-prev");
      const ugReviewNextArrow = this.querySelector(".ug-review__arrow-next");

      if (ugReviewPrevArrow && this.slider) {
        ugReviewPrevArrow.addEventListener("click", () => {
          this.slider.go("<");
        });
      }

      if (ugReviewNextArrow && this.slider) {
        ugReviewNextArrow.addEventListener("click", () => {
          this.slider.go(">");
        });
      }

      // Za hero-slider strelice (unutar svakog slide-a)
      const heroPrevArrows = this.querySelectorAll(".hero-slider__arrow-prev");
      const heroNextArrows = this.querySelectorAll(".hero-slider__arrow-next");

      if (heroPrevArrows.length > 0 && this.slider) {
        heroPrevArrows.forEach((arrow) => {
          arrow.addEventListener("click", () => {
            this.slider.go("<");
          });
        });
      }

      if (heroNextArrows.length > 0 && this.slider) {
        heroNextArrows.forEach((arrow) => {
          arrow.addEventListener("click", () => {
            this.slider.go(">");
          });
        });
      }
    }

    initProgressBar() {
      var bar = this.querySelector(".my-slider-progress-bar");

      if (!bar) {
        return;
      }

      // Updates the bar width whenever the carousel moves:
      this.slider.on(
        "mounted move",
        function () {
          var end = this.Components.Controller.getEnd() + 1;
          var rate = Math.min((this.index + 1) / end, 1);
          bar.style.width = String(100 * rate) + "%";
        }.bind(this.slider)
      );
    }
  }

  customElements.define("splide-slider-component", Slider);

  // NEMA više ručne inicijalizacije nad .js-slider!
  // Ako radiš u Theme Editoru, re-init na section load:
  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelectorAll("splide-slider-component").forEach((el) => {
      // Custom element će sam odraditi connectedCallback kad se doda u DOM
      // Ako je već u DOM-u i obnavlja se sadržaj, možemo ga forsirati:
      if (typeof el.ensureMarkup === "function") el.ensureMarkup();
      if (typeof el.initSlider === "function") el.initSlider();
    });
  });
})();
